const API_ROUTES = {
  // admin
  createAdmin: '/admin',
  getAdmins: '/admin',
  updateAdmin: '/admin/:id',
  deleteAdmin: '/admin/delete',

  // agent
  createAgent: '/agent',
  getAgents: '/agent',
  getAgentById: '/agent/:id',
  updateAgent: '/agent/:id',
  deleteAgent: '/agent/:id',

  // attendance routes
  createAttendance: '/attendance',
  getAttendance: '/attendance',
  updateAttendance: "/attendance/:id",
  deleteAttendance: "/attendance/:id",

  // auth routes
  checkUserExistence: "/auth/check-user-existence",
  verifyOTP: "/auth/verify-otp",
  checkUserProfiles: "/auth/check-user-profiles",
  getUserDetails: "/auth/get-user-details",
  getAccessToken: "/auth/get-access-token",

  // booking routes
  getBookings: '/booking',
  getBookingById: '/booking/:id',

  // car routes
  createCar: "/car",
  getCars: "/car",
  getCarById: "/car/:id",
  updateCar: "/car/:id",
  deleteCar: "/car/:id",

  // commissions routes
  getCommissions: "/commission",
  getCommissionById: "/commission/:id",

  // contact Us routes
  createContactUs: "/contact-us",
  getContactUs: "/contact-us",
  updateContactUs: "/contact-us/:id",
  deleteContactUs: "/contact-us/:id",

  // dealer routes
  createDealer: "/dealer",
  getDealers: "/dealer",
  getDealerById: "/dealer/:id",
  updateDealer: "/dealer/:id",
  deleteDealer: "/dealer/:id",

  // driver routes
  createDriver: "/driver",
  getDrivers: "/driver",
  getDriverById: "/driver/:id",
  updateDriver: "/driver/:id",
  deleteDriver: "/driver/:id",
  restoreDriver: "/driver/:id/restore",

  // expenses routes
  createExpense: "/expense",
  getExpenses: "/expense",
  getExpenseSummary: "/expense/summary",
  getExpenseById: "/expense/:id",
  updateExpense: "/expense/:id",
  deleteExpense: "/expense/:id",

  // enquiry routes
  createEnquiry: "/enquiry",
  getEnquiries: "/enquiry",
  updateEnquiry: "/enquiry/:id",
  deleteEnquiry: "/enquiry/:id",

  // service routes
  createService: "/service",
  getServices: "/service",
  updateService: "/service/:id",
  deleteService: "/service/:id",

  // invoice routes
  createInvoice: "/invoice",
  getInvoice: "/invoice",
  getRecentInvoices: "/invoice/recent",
  addInvoicePayment: "/invoice/:id/payment",
  updateInvoice: "/invoice/:id",

  // organization routes
  createOrganization: "/organization",
  organizationSignup: "/organization/signup",
  getOrganizations: "/organization",
  getOrganizationById: "/organization/:id",
  updateOrganization: "/organization/:id",
  approveOrganization: "/organization/:id/approve",
  deleteOrganization: "/organization/:id",

  // payments routes
  createPayment: "/payment",
  getPayments: "/payment",
  getPaymentById: "/payment/:id",
  updatePayment: "/payment/:id",
  deletePayment: "/payment/:id",

  // receipts routes
  getReceipts: "/receipt",
  getReceiptById: "/receipt/:id",

  // student routes
  createStudent: '/student',
  getStudents: '/student',
  getStudentById: '/student/:id',
  getStudentsWithActiveClasses: '/student/active-classes',
  updateStudent: "/student/:id",
  deleteStudent: '/student/:id',
  restoreStudent: '/student/:id/restore',

  // transaction routes
  createTransaction: "/transaction",
  verifyTransaction: "/transaction/verify",

  // videos routes
  createVideo: "/video",
  getVideos: "/video",
  updateVideo: "/video/:id",
  deleteVideo: "/video/:id",

  // video categories routes
  createVideoCategory: "/video-category",
  getVideoCategories: "/video-category",
  updateVideoCategory: "/video-category/:id",
  deleteVideoCategory: "/video-category/:id",

  // fuel card routes
  createFuelCardApplication: '/fuel-card',
  getFuelCardApplications: '/fuel-card',
  getFuelCardApplicationByOrg: '/fuel-card/organization/:organizationId',
  updateFuelCardApplication: '/fuel-card/:id',
  resubmitFuelCardApplication: '/fuel-card/my-application',

  // pre-signed url routes
  getPreSignedUrl: "/upload/presigned-urls",

  // referral routes
  getReferrals: "/referral",
  getReferralById: "/referral/:id",
  markReferralPayment: "/referral/:id/payment",

  // batch routes
  createBatch: "/batch",
  getBatches: "/batch",
  getBatchById: "/batch/:id",
  updateBatch: "/batch/:id",
  deleteBatch: "/batch/:id",
  assignStudentToBatch: "/batch/:batchId/students/:studentId",
  removeStudentFromBatch: "/batch/:batchId/students/:studentId",

  // public routes
  getPublicOrganizations: "/public/organizations",
  getPublicDealers: "/public/dealers",
};

export default API_ROUTES;
